import { Dispatch } from "redux"
import { AppStateWithData } from "../../../.."
import { ApiConfig, createRequestActionTypes, createRequestThunk, FetchRequestActions, RequestThunkParameters, UserReadConfirmItems } from "../../../../.."
import { processFetchReadConfirmResponse } from "./processFetchReadConfirmResponse"

export type FetchUserReadConfirmAction = FetchRequestActions<UserReadConfirmItems>

export const fetchReadConfirmActionTypes = createRequestActionTypes("FETCH_USER_READ_CONFIRM")

export const fetchUserReadConfirm = (config: ApiConfig) => () => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<UserReadConfirmItems> = {
        method: 'GET',
        requestActionTypes: fetchReadConfirmActionTypes,
        url: `${config.API_URL}/mustRead/user`,
        processResultBeforeDispatch: processFetchReadConfirmResponse(dispatch)
    }
    return createRequestThunk(thunkParams)(dispatch, getState)
}